import type { SellerOfferDTO } from "@recruiter/shared";

// The client's quality bar for a custom offer, on JUNO's 0-100 fit scale. Mirror
// of the backend's single source of truth — recruiter/concierge/tools.py
// `OFFER_VALID_FIT_MIN` (and `is_valid_offer`). The worker only ACCEPTS an offer
// that clears this bar (seller_turn → thread state `offer_received`); below it
// STERLING re-runs to push back for stronger terms and the offer is never shown
// to the client. Keep this in lockstep with the backend constant.
export const OFFER_VALID_FIT_MIN = 60;

// True iff the offer cleared the bar — i.e. STERLING accepted it and forwarded it
// to the client. A below-bar offer is still captured/persisted, but it is NOT
// accepted, so the talent must not be shown it as a done, valid offer.
export function isOfferAccepted(offer: Pick<SellerOfferDTO, "fit_score">): boolean {
  return offer.fit_score >= OFFER_VALID_FIT_MIN;
}
